import { defineComponent, ref, nextTick } from "@vue/composition-api";
import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
export default defineComponent({
  name: "RemoveComponentModal",
  components: {
    GenericModal,
    SimpleButton
  },
  props: {
    text: {
      type: String,
      required: true
    }
  },
  setup(props, {
    emit
  }) {
    const modalData = ref({});
    const removeComponentModal = ref(null);
    const handleAcceptDeletion = async () => {
      emit("accept", modalData.value);
      await nextTick();
      removeComponentModal.value.hide();
    };
    const hidden = () => {
      modalData.value = {};
    };
    const openModal = data => {
      modalData.value = data;
      removeComponentModal.value.show();
    };
    return {
      handleAcceptDeletion,
      hidden,
      openModal,
      removeComponentModal,
      modalData
    };
  }
});